import {BaseCache} from "./base";

class TokenCache extends BaseCache {
  constructor() {
    super();
    this.key = 'token';
  }
}

export const tokenCache = new TokenCache();
